import styled from "styled-components";

export const AnimationLoading = styled.div`
  animation-duration: 1s;
  animation-fill-mode: forwards;
  animation-iteration-count: infinite;
  animation-name: placeHolderShimmer;
  animation-timing-function: linear;
  background-size: 1400px 104px;
  background: #ffffff;
  background: linear-gradient(to right, #ffffff 8%, #f6f6f6 18%, #ffffff 33%);
  border-radius: 1rem;
  height: 6.3rem;
  margin: 1rem 0;
  position: relative;

  @keyframes placeHolderShimmer {
    0% {
      background-position: -668px 0;
    }
    100% {
      background-position: 668px 0;
    }
  }
`;
